import { useCallback, useState } from 'react'

import { SubmitFormRequestElementResult } from '@cash-web/protos/squareup/franklin/app/submit_form.pb'

export type PendingBlockerInput = {
  blockerDescriptorId: string
  inputs: SubmitFormRequestElementResult[]
  actionId?: string
}

type SubmissionAccumulatorState = {
  pendingInputs: Map<string, PendingBlockerInput>
  currentGroupId?: string
}

export function useSubmissionAccumulator() {
  const [state, setState] = useState<SubmissionAccumulatorState>({
    pendingInputs: new Map(),
    currentGroupId: undefined,
  })

  const accumulate = useCallback(
    (blockerId: string, inputs: SubmitFormRequestElementResult[], actionId?: string, groupId?: string) => {
      setState(prev => ({
        pendingInputs: new Map(prev.pendingInputs).set(blockerId, {
          blockerDescriptorId: blockerId,
          inputs,
          actionId,
        }),
        currentGroupId: groupId,
      }))
    },
    []
  )

  const getAllInputs = useCallback(() => {
    return Array.from(state.pendingInputs.values())
  }, [state.pendingInputs])

  const clear = useCallback(() => {
    setState({ pendingInputs: new Map(), currentGroupId: undefined })
  }, [])

  return {
    accumulate,
    getAllInputs,
    clear,
    currentGroupId: state.currentGroupId,
    hasPendingInputs: state.pendingInputs.size > 0,
  }
}
